import React from 'react';
import classNames from 'classnames';

import styles from './Dropdown.module.scss';

export interface ToggleProps {
  className?: string;
  // children: React.ReactNode; // props interface extends FC interface
  isOpen?: boolean;
  handleToggle?: () => void;
}

const Toggle: React.FC<ToggleProps & React.HTMLAttributes<HTMLButtonElement>> = props => {
  const { children, className, isOpen, handleToggle, ...restProps } = props;

  return (
    <button
      type="button"
      className={classNames(styles.button, { [styles.active]: isOpen }, className)}
      onClick={() => handleToggle && handleToggle()}
      {...restProps}
    >
      {/* ☰ */}
      {children}
    </button>
  );
};

export default Toggle;
